<template>
  <div class="audience-cta-wrapper">
    <div class="container">
      <p class="top-msg">
        {{ $t('thank_for_participation') }}
      </p>

      <div v-if="isShownCTAButtons" class="audience-cta-buttons">
        <aha-antd-button
          v-if="isEnableSlideReview"
          class="cta-button"
          variant="secondary"
          iconName="presenter-light"
          iconWidth="16"
          iconHeight="16"
          iconViewBox="0 0 16 18"
          @click="openTabLookback"
          data-testid="audience-footer-review-slides-button"
        >
          <span>{{ $t('review_slides') }}</span>
        </aha-antd-button>

        <aha-antd-button
          v-if="isEnableFeedback"
          class="cta-button"
          variant="secondary"
          :disabled="isDisabledFeedbackButton"
          iconName="feedback"
          iconWidth="16"
          iconHeight="16"
          iconViewBox="0 0 18 18"
          @click="openTabFeedback"
          data-testid="audience-footer-give-feedback-button"
        >
          <span>{{ $t('give_feedback') }}</span>
        </aha-antd-button>
      </div>
      <div
        v-if="isShowAhaSection"
        class="audience-cta-link"
      >
        <div class="aha-icon-wrapper">
          <aha-logo
            :icon-only="true"
            :useDefaultColor="true"
            class="img-link"
            width="26"
            height="26"
            data-testid="audience-footer-get-ahaslides-free-button"
            @click="openTrialLink"
          />
        </div>
        <span
          class="text-link"
          @click="openTrialLink"
          data-testid="audience-footer-get-ahaslides-free-link"
        >
          {{ $t('get_ahaslides_free') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import util from '@/util'
import config from '@/config'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slides: (state) => state.slides,
    }),
    ...mapGetters(['isEnableFeedback', 'isEnableSlideReview']),
    isShownCTAButtons() {
      return this.isEnableFeedback || this.isEnableSlideReview
    },
    isEnableAudienceAhaSlideLabel() {
      return this.presentation && this.presentation.isEnableAudienceAhaSlideLabel
    },
    isShowAhaSection() {
      return this.isEnableAudienceAhaSlideLabel
    },
    isDisabledFeedbackButton() {
      return !this.presentation || !this.presentation.isEnablePrivateFeedback
    },
    trialLink() {
      const presentationId = this.presentation && this.presentation.id
      const params = new URLSearchParams({
        source: 'audience_app',
        presentationid: presentationId,
        campaign: 'audience_app',
      })

      return `${config.presenterUrl}/pages/register?${params.toString()}`
    },
  },
  methods: {
    ...mapActions([
      'setMaxLookbackSlideIndexAction',
    ]),
    openTabLookback() {
      this.setMaxLookbackSlideIndexAction(this.slides.length - 1)

      this.$router.push({
        name: 'lookback',
        params: {
          presentationId: this.$route.params.id,
        },
        query: {
          'lookback-tab': 'slides',
        },
      })

      util.ga4Track('Presentation > Review slides', {
        presentationId: this.presentation && this.presentation.id,
      })
    },
    openTabFeedback() {
      this.$router.push({
        name: 'feedback',
        params: {
          presentationId: this.$route.params.id,
        },
      })
      util.ga4Track('Presentation > Give feedback', {
        presentationId: this.presentation && this.presentation.id,
      })
    },
    openTrialLink() {
      window.open(this.trialLink, '_blank')
      util.ga4Track('Presentation > AhaSlides for free', {
        presentationId: this.presentation && this.presentation.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
body.is-audience-paced {
  .audience-cta-wrapper {
    padding-bottom: var(--h-audience-paced);
  }
}

.audience-cta-wrapper {
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  text-decoration: none;
  background-color: #F0F4FA;
  text-align: center;
  color: #282E3E;
}

.container {
  padding: 32px 16px 24px 16px;
  max-width: 392px;
  margin: 0 auto;

  @media screen and (min-width: 600px) {
    max-width: 600px;
  }
}

.top-msg {
  margin: 0;
}

.audience-cta-buttons {
  text-align: center;
  width: 100%;
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  column-gap: 8px;
  row-gap: 12px;
}

.audience-cta-link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 0;
  margin-top: 16px;

  .aha-icon-wrapper {
    width: 26px;
    height: 26px;

    .img-link {
      cursor: pointer;
      width: 26px;
      height: 26px;
    }
  }

  .text-link {
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 600;
    margin-left: 8px;
    margin-bottom: -2px; // hack vertical align
    text-decoration: underline;
  }
}
</style>
